import Report from '../components/views/reports/Report.vue'
import ReportCreate from '../components/views/reports/ReportCreate.vue'

const routes = [{
        path: 'reports',
        component: Report,
        name: 'Report',
        meta: {
            title: 'Reports History',
            requiresAuth: true
        }
    },
    {
        path: 'reports/create',
        component: ReportCreate,
        name: 'ReportCreate',
        meta: {
            title: 'Generate Report',
            requiresAuth: true
        }
    }
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/reportgeneration.route.js